// Sample articles data for the Articles component
export const articlesData = [
  {
    id: '1',
    title: 'Introduction to Cybersecurity',
    content: 'This comprehensive guide covers the fundamentals of cybersecurity, including threat identification, risk assessment, and basic protection strategies. Learn about common attack vectors, security frameworks, and best practices for maintaining a secure digital environment.',
    excerpt: 'Learn the basics of cybersecurity in this introductory article covering threat identification and protection strategies.',
    category: 'cybersecurity',
    difficulty: 'beginner',
    author_name: 'CyberGov Team',
    author_id: 'admin-1',
    status: 'published',
    featured: true,
    published_at: '2024-01-15T10:00:00Z',
    created_at: '2024-01-15T10:00:00Z',
    updated_at: '2024-01-15T10:00:00Z',
    views: 1250,
    likes: 89,
    reading_time: 8,
    tags: ['cybersecurity', 'basics', 'introduction', 'security']
  },
  {
    id: '2',
    title: 'Advanced Threat Detection Techniques',
    content: 'Explore sophisticated methods for identifying and mitigating advanced persistent threats (APTs). This article covers machine learning approaches, behavioral analysis, and cutting-edge detection technologies used by security professionals.',
    excerpt: 'Discover advanced threat detection methodologies and cutting-edge security technologies.',
    category: 'cybersecurity',
    difficulty: 'advanced',
    author_name: 'Dr. Sarah Chen',
    author_id: 'expert-1',
    status: 'published',
    featured: false,
    published_at: '2024-01-20T14:30:00Z',
    created_at: '2024-01-20T14:30:00Z',
    updated_at: '2024-01-20T14:30:00Z',
    views: 892,
    likes: 67,
    reading_time: 12,
    tags: ['threat-detection', 'advanced', 'machine-learning', 'APT']
  },
  {
    id: '3',
    title: 'Data Privacy Best Practices',
    content: 'Essential practices for maintaining data privacy and compliance with regulations like GDPR and CCPA. Learn about data classification, encryption methods, access controls, and privacy by design principles.',
    excerpt: 'Learn how to protect sensitive data effectively and maintain regulatory compliance.',
    category: 'privacy',
    difficulty: 'intermediate',
    author_name: 'Michael Rodriguez',
    author_id: 'expert-2',
    status: 'published',
    featured: true,
    published_at: '2024-01-25T09:15:00Z',
    created_at: '2024-01-25T09:15:00Z',
    updated_at: '2024-01-25T09:15:00Z',
    views: 1456,
    likes: 112,
    reading_time: 10,
    tags: ['privacy', 'GDPR', 'compliance', 'data-protection']
  },
  {
    id: '4',
    title: 'Network Security Fundamentals',
    content: 'Understanding the basics of network security including firewalls, intrusion detection systems, VPNs, and network segmentation. This guide provides practical insights for securing network infrastructure.',
    excerpt: 'Master the fundamentals of network security and infrastructure protection.',
    category: 'network-security',
    difficulty: 'beginner',
    author_name: 'Alex Thompson',
    author_id: 'expert-3',
    status: 'published',
    featured: false,
    published_at: '2024-02-01T11:45:00Z',
    created_at: '2024-02-01T11:45:00Z',
    updated_at: '2024-02-01T11:45:00Z',
    views: 743,
    likes: 54,
    reading_time: 9,
    tags: ['network-security', 'firewalls', 'VPN', 'infrastructure']
  },
  {
    id: '5',
    title: 'Incident Response Planning',
    content: 'Comprehensive guide to developing and implementing effective incident response plans. Learn about incident classification, response teams, communication protocols, and post-incident analysis.',
    excerpt: 'Develop effective incident response strategies and protocols for your organization.',
    category: 'incident-response',
    difficulty: 'intermediate',
    author_name: 'Jennifer Park',
    author_id: 'expert-4',
    status: 'published',
    featured: true,
    published_at: '2024-02-05T16:20:00Z',
    created_at: '2024-02-05T16:20:00Z',
    updated_at: '2024-02-05T16:20:00Z',
    views: 987,
    likes: 78,
    reading_time: 11,
    tags: ['incident-response', 'planning', 'protocols', 'analysis']
  },
  {
    id: '6',
    title: 'Cloud Security Architecture',
    content: 'Best practices for securing cloud environments including AWS, Azure, and Google Cloud. Covers identity management, encryption, monitoring, and compliance in cloud deployments.',
    excerpt: 'Secure your cloud infrastructure with proven architecture patterns and best practices.',
    category: 'cloud-security',
    difficulty: 'advanced',
    author_name: 'David Kim',
    author_id: 'expert-5',
    status: 'published',
    featured: false,
    published_at: '2024-02-10T13:10:00Z',
    created_at: '2024-02-10T13:10:00Z',
    updated_at: '2024-02-10T13:10:00Z',
    views: 654,
    likes: 45,
    reading_time: 13,
    tags: ['cloud-security', 'AWS', 'Azure', 'architecture']
  },
  {
    id: '7',
    title: 'Mobile Device Security',
    content: 'Protecting mobile devices in enterprise environments. Learn about mobile device management (MDM), app security, BYOD policies, and mobile threat protection strategies.',
    excerpt: 'Implement comprehensive mobile device security for your organization.',
    category: 'mobile-security',
    difficulty: 'intermediate',
    author_name: 'Lisa Wang',
    author_id: 'expert-6',
    status: 'published',
    featured: false,
    published_at: '2024-02-15T08:30:00Z',
    created_at: '2024-02-15T08:30:00Z',
    updated_at: '2024-02-15T08:30:00Z',
    views: 521,
    likes: 38,
    reading_time: 7,
    tags: ['mobile-security', 'MDM', 'BYOD', 'enterprise']
  },
  {
    id: '8',
    title: 'Zero Trust Security Model',
    content: 'Understanding and implementing the Zero Trust security framework. Covers principles, architecture, implementation strategies, and real-world case studies of Zero Trust deployments.',
    excerpt: 'Explore the Zero Trust security model and its implementation in modern organizations.',
    category: 'cybersecurity',
    difficulty: 'advanced',
    author_name: 'Robert Johnson',
    author_id: 'expert-7',
    status: 'published',
    featured: true,
    published_at: '2024-02-20T15:45:00Z',
    created_at: '2024-02-20T15:45:00Z',
    updated_at: '2024-02-20T15:45:00Z',
    views: 1123,
    likes: 95,
    reading_time: 14,
    tags: ['zero-trust', 'security-model', 'architecture', 'framework']
  },
  {
    id: '9',
    title: 'Social Engineering Awareness',
    content: 'Recognizing and defending against social engineering attacks. Learn about common tactics, psychological manipulation techniques, and how to build organizational awareness and resistance.',
    excerpt: 'Build awareness and defenses against social engineering attacks and manipulation.',
    category: 'awareness',
    difficulty: 'beginner',
    author_name: 'Emma Davis',
    author_id: 'expert-8',
    status: 'published',
    featured: false,
    published_at: '2024-02-25T12:00:00Z',
    created_at: '2024-02-25T12:00:00Z',
    updated_at: '2024-02-25T12:00:00Z',
    views: 834,
    likes: 62,
    reading_time: 6,
    tags: ['social-engineering', 'awareness', 'training', 'psychology']
  },
  {
    id: '10',
    title: 'Cryptography Essentials',
    content: 'Fundamental concepts of cryptography including symmetric and asymmetric encryption, hashing, digital signatures, and key management. Practical applications in modern security systems.',
    excerpt: 'Master the essential concepts of cryptography and their practical applications.',
    category: 'cryptography',
    difficulty: 'intermediate',
    author_name: 'Dr. Ahmed Hassan',
    author_id: 'expert-9',
    status: 'published',
    featured: true,
    published_at: '2024-03-01T10:30:00Z',
    created_at: '2024-03-01T10:30:00Z',
    updated_at: '2024-03-01T10:30:00Z',
    views: 1067,
    likes: 84,
    reading_time: 15,
    tags: ['cryptography', 'encryption', 'hashing', 'digital-signatures']
  },
  {
    id: '11',
    title: 'AI-Powered Security Analytics (Draft)',
    content: 'Exploring the use of artificial intelligence and machine learning in cybersecurity analytics. This draft covers emerging trends, implementation challenges, and future prospects.',
    excerpt: 'Discover how AI is revolutionizing cybersecurity analytics and threat detection.',
    category: 'cybersecurity',
    difficulty: 'advanced',
    author_name: 'Dr. Emily Chen',
    author_id: 'expert-10',
    status: 'draft',
    featured: false,
    published_at: null,
    created_at: '2024-03-05T14:20:00Z',
    updated_at: '2024-03-05T14:20:00Z',
    views: 0,
    likes: 0,
    reading_time: 12,
    tags: ['AI', 'machine-learning', 'analytics', 'emerging-tech']
  },
  {
    id: '12',
    title: 'Quantum Computing Security Implications (Draft)',
    content: 'Understanding the security implications of quantum computing technology. This draft explores quantum-resistant cryptography and preparing for the post-quantum era.',
    excerpt: 'Prepare for the quantum computing revolution and its impact on cybersecurity.',
    category: 'cryptography',
    difficulty: 'advanced',
    author_name: 'Prof. James Wilson',
    author_id: 'expert-11',
    status: 'draft',
    featured: false,
    published_at: null,
    created_at: '2024-03-08T11:15:00Z',
    updated_at: '2024-03-08T11:15:00Z',
    views: 0,
    likes: 0,
    reading_time: 18,
    tags: ['quantum-computing', 'post-quantum', 'cryptography', 'future-tech']
  },
  {
    id: '13',
    title: 'IoT Security Best Practices (Draft)',
    content: 'Comprehensive guide to securing Internet of Things devices in enterprise environments. This draft covers device management, network segmentation, and monitoring strategies.',
    excerpt: 'Learn essential practices for securing IoT devices in your organization.',
    category: 'network-security',
    difficulty: 'intermediate',
    author_name: 'Maria Gonzalez',
    author_id: 'expert-12',
    status: 'draft',
    featured: false,
    published_at: null,
    created_at: '2024-03-10T09:30:00Z',
    updated_at: '2024-03-10T09:30:00Z',
    views: 0,
    likes: 0,
    reading_time: 9,
    tags: ['IoT', 'device-security', 'network-segmentation', 'monitoring']
  }
];

// Categories for filtering
export const articleCategories = [
  { value: '', label: 'All Categories' },
  { value: 'cybersecurity', label: 'Cybersecurity' },
  { value: 'privacy', label: 'Privacy' },
  { value: 'network-security', label: 'Network Security' },
  { value: 'incident-response', label: 'Incident Response' },
  { value: 'cloud-security', label: 'Cloud Security' },
  { value: 'mobile-security', label: 'Mobile Security' },
  { value: 'awareness', label: 'Security Awareness' },
  { value: 'cryptography', label: 'Cryptography' }
];

// Difficulty levels
export const difficultyLevels = [
  { value: '', label: 'All Levels' },
  { value: 'beginner', label: 'Beginner' },
  { value: 'intermediate', label: 'Intermediate' },
  { value: 'advanced', label: 'Advanced' }
];

// Status options
export const statusOptions = [
  { value: '', label: 'All Status' },
  { value: 'published', label: 'Published' },
  { value: 'draft', label: 'Draft' },
  { value: 'review', label: 'Under Review' }
];